module.exports = __webpack_public_path__ + "static/media/hip_adduction_machine.8f544103.png";